<template>
  <div class="flex justify-between w-full overflow-hidden mb-8">
    <div
      class="flex-1 flex mr-40 items-center overflow-hidden text-left leading-14"
    >
      <span class="text-#333">Order ID:</span>
      <span class="text-#999 flex-1 truncate">
        {{ orderId }}
      </span>
      <img
        src="@/assets/images/common/copy.png"
        class="size-11 ml-6"
        @click="handleCopyOrderId(orderId)"
      />
    </div>
    <span class="text-#FDBB2B">{{ renderOrderStatus(goods.status) }}</span>
  </div>
  <div class="flex">
    <img class="size-88 mr-6 bg-#D8D8D8 rounded-8" :src="goods.imgUrl" />
    <div class="flex-1 flex flex-col justify-between overflow-hidden">
      <div class="text-#333 text-left leading-14 line-clamp-2">
        {{ goods.goodsName }}
      </div>
      <div
        class="text-#999 leading-17 flex justify-between items-center flex-1"
      >
        <span class="font-400">{{ goods.skuName }}</span>
        <span class="font-600">x{{ goods.num }}</span>
      </div>
      <div class="flex justify-between">
        <div class="text-14 text-#333 font-bold">
          {{ formatPrice(goods.price) }}
        </div>
        <div
          class="bg-#FFC045 rounded-14 w-73 h-24 flex justify-center items-center text-10 text-#333 font-600"
          @click="$emit('send', $props)"
        >
          {{ $t('message.send') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useSetting } from "@/composables/use-setting";
import { showToast } from "vant";
import { useI18n } from 'vue-i18n'

const { t } = useI18n();

defineProps<{
  orderId: string;
  goods: any;
}>();

defineEmits<{
  send: [any];
}>();

const { formatPrice } = useSetting();

const handleCopyOrderId = (id: string) => {
  try {
    navigator.clipboard.writeText(id);
    showToast("Copied");
  } catch {}
};

const renderOrderStatus = (status) => {
  switch (status) {
    case 0:
      return t('message.unpaid');
    case 5:
      return t('message.inviting');
    case 10:
      return t('message.tobeshipped');
    case 20:
      return t('message.processing');
    case 22:
      return t('message.qualityInspection');
    case 23:
      return t('message.qualityInspectionFailed');
    case 24:
      return t('message.preparingForShipment');
    case 25:
      return t('message.shipped');
    case 30:
      return t('message.received');
    case 35:
      return t('message.received');
    case 40:
      return t('message.cancel');
    case 50:
      return t('message.approved');
    case 60:
      return t('message.refunding');
    case 70:
      return t('message.refunded');
    case 90:
      return t('message.refundRejected');
    case 100:
      return t('message.received');
    default:
      return '';
  }
}

</script>
